import store from "@/store";

const routes = [
  {
    path: "/accounting/debit-memo-history/:id",
    name: "acctdebitmemohistory",
    component: () => import("@/views/main/modules/Accounting/DebitMemoHistory/DebitMemoHistoryGroupComponent.vue"),
    beforeEnter: (to, from, next) => {
      store
        .dispatch("checkAccessUser", to.params.id)
        .then((response) => {
          if (response == "fail") {
            next("/no-access");
          } else {
            next();
          }
        })
        .catch(() => {});
    },
    meta: {
      requiresAuth: true,
      title: "Debit Memo (Change Date)",
    },
  },
];

export default routes;
